import TableActions from "../../components/others/TableActions/TableActions";

/**
 * Configuración de columnas para las tablas del módulo UsersRoles
 * @param onEdit - Callback que se ejecuta al hacer clic en editar
 * @param options - Opciones para personalizar las columnas
 * @returns Array de configuración de columnas
 */
interface ColumnOptions {
  showEmail?: boolean;
  showEmailEnabled?: boolean;
}

export const getUserRolesTableColumns = (
  onEdit: (rowData: any) => void,
  options: ColumnOptions = { showEmail: true, showEmailEnabled: true }
) => {
  const columns: any[] = [
    {
      key: 'name',
      title: 'Apellido y Nombre',
      className: 'col-name',
      expandable: false,
      render: (value: any, row: any) => (
        <div className="patient-name-cell">
          {row?.name || "---"}
        </div>
      )
    },
    {
      key: 'DNI',
      title: 'DNI',
      className: 'col-dni',
      render: (value: any) => value || "---"
    },
    {
      key: 'username',
      title: 'Usuario',
      className: 'col-usuario',
      render: (value: any) => value || "---"
    },
  ];

  // Agregar columna de email si está habilitada
  if (options.showEmail) {
    columns.push({
      key: 'email',
      title: 'Email',
      className: 'col-email',
      render: (value: any) => value || "---"
    });
  }

  // Agregar columna de activo
  columns.push({
    key: 'activo',
    title: 'Activo',
    className: 'col-activo',
    render: (value: any, row: any) => row.enabled ? "Si" : "No"
  });

  // Agregar columna de email habilitado si está configurada
  if (options.showEmailEnabled) {
    columns.push({
      key: 'habilitadoParaRecibirEmails',
      title: 'Habilitado para recibir emails',
      className: 'col-email-enabled',
      render: (value: any) => value ? "Si" : "No"
    });
  }

  // Agregar columna de acciones
  columns.push({
    key: 'actions',
    title: 'Acciones',
    className: 'col-actions',
    render: (value: any, rowData: any) => (
      <div className="flex gap-2 justify-center">
        <TableActions
          type="Edit"
          onClick={() => onEdit(rowData)}
        />
      </div>
    )
  });

  return columns;
};

